export const MFA_LOGIN_STORAGE_KEY = 'bluesite-login-mfa-challenge'
export const MFA_TRUSTED_DEVICE_STORAGE_KEY = 'bluesite-mfa-trusted-device'

export interface IMfaChallengeSession {
  challengeToken: string
  email: string
  userName: string
  companyId: number
  role: string
  canRememberDevice: boolean
  lastAccessAt?: string
  expiresInMinutes: number
  sentAt: string
  resendCount: number
  attemptsLeft: number
}
